import React, { useState, useEffect } from 'react';
import './fullReport.scss';
import { usePortal } from 'context';

const FullReport = () => {
    const {
        user: { partnerAccent, viewReportUrl },
    } = usePortal();

    return (
        <div className="report-container">
            <h2 style={{ color: partnerAccent ? partnerAccent : undefined }}>{'The View Report'}</h2>
            <div className="report-content">
                <iframe className="report-display" src={viewReportUrl}></iframe>
            </div>
        </div>
    );
};

export default FullReport;
